import React, { useState, useEffect } from 'react';

const SizeConverter = () => {
  // 状态管理
  const [inputValue, setInputValue] = useState('');
  const [inputUnit, setInputUnit] = useState('cm');
  const [results, setResults] = useState({
    cm: 0,
    inch: 0,
    fr: 0
  });

  // 转换逻辑
  const convertSize = (value, unit) => {
    let cm = 0;
    
    // 先转换为厘米
    switch (unit) {
      case 'cm':
        cm = parseFloat(value) || 0;
        break;
      case 'inch':
        cm = (parseFloat(value) || 0) * 2.54;
        break;
      case 'fr':
        cm = (parseFloat(value) || 0) / 2;
        break;
      default:
        cm = 0;
    }

    // 再转换为其他单位
    return {
      cm: cm,
      inch: cm / 2.54,
      fr: cm * 2
    };
  };

  // 处理输入变化
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setResults(convertSize(value, inputUnit));
  };

  // 处理单位变化
  const handleUnitChange = (e) => {
    const unit = e.target.value;
    setInputUnit(unit);
    setResults(convertSize(inputValue, unit));
  };

  // 初始化转换
  useEffect(() => {
    setResults(convertSize(inputValue, inputUnit));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-teal-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-blue-800">
          手链尺寸换算表
        </h1>
        
        {/* 输入区域 */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8 border border-blue-100">
          <h2 className="text-xl font-semibold mb-6 text-blue-700 text-center">
            输入尺寸
          </h2>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <input
              type="number"
              value={inputValue}
              onChange={handleInputChange}
              placeholder="请输入尺寸"
              className="px-6 py-3 rounded-lg border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center text-xl w-full md:w-1/3"
              min="0"
              step="0.1"
            />
            <select
              value={inputUnit}
              onChange={handleUnitChange}
              className="px-6 py-3 rounded-lg border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-blue-800 font-medium"
            >
              <option value="cm">厘米 (cm)</option>
              <option value="inch">英寸 (inch)</option>
              <option value="fr">法国尺码 (FR)</option>
            </select>
          </div>
        </div>

        {/* 结果展示 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl shadow-lg p-6 border border-blue-100 text-center">
            <h3 className="text-gray-600 mb-2">厘米 (cm)</h3>
            <p className="text-4xl font-bold text-blue-800">
              {results.cm.toFixed(2)}
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-6 border border-teal-100 text-center">
            <h3 className="text-gray-600 mb-2">英寸 (inch)</h3>
            <p className="text-4xl font-bold text-teal-800">
              {results.inch.toFixed(2)}
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-6 border border-purple-100 text-center">
            <h3 className="text-gray-600 mb-2">法国尺码 (FR)</h3>
            <p className="text-4xl font-bold text-purple-800">
              {results.fr.toFixed(2)}
            </p>
          </div>
        </div>

        {/* 尺码参考表 */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mt-8 border border-blue-100">
          <h2 className="text-xl font-semibold mb-6 text-blue-700 text-center">
            尺码参考表
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-blue-50">
                  <th className="border border-blue-200 px-4 py-3 text-left text-blue-800 font-medium">手链类型</th>
                  <th className="border border-blue-200 px-4 py-3 text-center text-blue-800 font-medium">建议长度 (cm)</th>
                  <th className="border border-blue-200 px-4 py-3 text-center text-blue-800 font-medium">法国尺码 (FR)</th>
                </tr>
              </thead>
              <tbody>
                <tr className="hover:bg-blue-50 transition-colors">
                  <td className="border border-blue-200 px-4 py-3">单圈手链</td>
                  <td className="border border-blue-200 px-4 py-3 text-center">17-19</td>
                  <td className="border border-blue-200 px-4 py-3 text-center">34-38</td>
                </tr>
                <tr className="hover:bg-blue-50 transition-colors">
                  <td className="border border-blue-200 px-4 py-3">双圈手链</td>
                  <td className="border border-blue-200 px-4 py-3 text-center">34-38</td>
                  <td className="border border-blue-200 px-4 py-3 text-center">68-76</td>
                </tr>
                <tr className="hover:bg-blue-50 transition-colors">
                  <td className="border border-blue-200 px-4 py-3">三圈手链</td>
                  <td className="border border-blue-200 px-4 py-3 text-center">51-57</td>
                  <td className="border border-blue-200 px-4 py-3 text-center">102-114</td>
                </tr>
                <tr className="hover:bg-blue-50 transition-colors">
                  <td className="border border-blue-200 px-4 py-3">儿童手链</td>
                  <td className="border border-blue-200 px-4 py-3 text-center">14-16</td>
                  <td className="border border-blue-200 px-4 py-3 text-center">28-32</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeConverter;